import { __assign } from "tslib";
import React from "react";
import * as ReactDOM from "react-dom";
import { Grid, Typography, Dialog, DialogActions, DialogContent, DialogTitle, Button, IconButton, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import CloseIcon from "@material-ui/icons/Close";
var useStyles = makeStyles(function (theme) {
  return {
    header: {
      padding: theme.spacing(2)
    },
    content: {
      padding: theme.spacing(2)
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    actions: {
      padding: theme.spacing(1)
    },
    noBorder: {
      padding: 0
    },
    footer: {
      margin: theme.spacing(0, 1)
    },
    button: {
      textTransform: "none"
    }
  };
});

var OriginModal = function OriginModal(_a) {
  var _b = _a.open,
      open = _b === void 0 ? true : _b,
      title = _a.title,
      _c = _a.fullWidth,
      fullWidth = _c === void 0 ? true : _c,
      _d = _a.maxWidth,
      maxWidth = _d === void 0 ? "sm" : _d,
      _e = _a.dividers,
      dividers = _e === void 0 ? true : _e,
      _f = _a.noBorder,
      noBorder = _f === void 0 ? false : _f,
      suffix = _a.suffix,
      extraText = _a.extraText,
      extraInfo = _a.extraInfo,
      hideCancel = _a.hideCancel,
      hideActions = _a.hideActions,
      content = _a.content,
      okText = _a.okText,
      cancelText = _a.cancelText,
      clearText = _a.clearText,
      children = _a.children,
      submitBtnDisabled = _a.submitBtnDisabled,
      onClose = _a.onClose,
      onConfirm = _a.onConfirm,
      onClear = _a.onClear,
      dialogClasses = _a.dialogClasses;
  var classes = useStyles();
  return React.createElement(Dialog, {
    open: open,
    fullWidth: fullWidth,
    maxWidth: maxWidth,
    onClose: onClose,
    classes: dialogClasses
  }, React.createElement(DialogTitle, {
    className: classes.header
  }, React.createElement(Grid, {
    container: true,
    justify: "space-between",
    alignItems: "center"
  }, React.createElement(Grid, {
    container: true,
    direction: "row",
    alignItems: "center"
  }, React.createElement(Typography, {
    variant: "h6"
  }, title), React.createElement(Typography, {
    style: {
      paddingLeft: "6px",
      paddingTop: "4px",
      fontSize: "10px",
      fontWeight: "bold"
    },
    color: "primary"
  }, suffix)), React.createElement(IconButton, {
    "aria-label": "close",
    onClick: onClose,
    className: classes.closeButton
  }, React.createElement(CloseIcon, null)))), React.createElement(DialogContent, {
    dividers: dividers,
    className: clsx(classes.content, noBorder && classes.noBorder)
  }, content || children), !hideActions && React.createElement(DialogActions, {
    className: classes.actions
  }, React.createElement(Grid, {
    className: classes.footer,
    container: true,
    alignItems: "center",
    justify: "space-between"
  }, React.createElement(Grid, {
    item: true
  }, extraInfo || React.createElement(Typography, {
    variant: "body2"
  }, extraText)), React.createElement(Grid, {
    item: true
  }, onClear && React.createElement(Button, {
    className: classes.button,
    onClick: onClear,
    style: {
      marginRight: 8
    },
    color: "primary"
  }, clearText || "Clear"), !hideCancel && React.createElement(Button, {
    className: classes.button,
    onClick: onClose,
    style: {
      marginRight: 8
    },
    color: "primary"
  }, cancelText || "Cancel"), React.createElement(Button, {
    className: classes.button,
    autoFocus: true,
    onClick: onConfirm,
    color: "primary",
    variant: "contained",
    disabled: submitBtnDisabled
  }, okText || "Done")))));
};

export function confirm(props) {
  var onClose = props.onClose,
      onConfirm = props.onConfirm;
  var div = document.createElement("div");
  document.body.appendChild(div);

  function handleClose() {
    destroy();
    onClose && onClose();
  }

  function handleConfirm() {
    destroy();
    onConfirm && onConfirm();
  }

  function destroy() {
    var umount = ReactDOM.unmountComponentAtNode(div);

    if (umount && div.parentNode) {
      div.parentNode.removeChild(div);
    }
  }

  setTimeout(function () {
    ReactDOM.render(React.createElement(OriginModal, __assign({}, props, {
      onClose: handleClose,
      onConfirm: handleConfirm
    })), div);
  });
}
var Modal = OriginModal;
Modal.confirm = confirm;
export default Modal;